import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import { toast } from 'sonner';
import { Mail, ChevronRight, Palette } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

const TYPE_ICONS = {
  welcome: '👋',
  enrollment_confirmation: '✅',
  session_reminder: '⏰',
  certificate_available: '🎓',
  status_change: '🔄',
  announcement: '📢',
  survey: '📝',
  password_reset: '🔑',
  forum_reply: '💬',
  forum_new_topic: '📌',
};

const EmailTemplates = () => {
  const navigate = useNavigate();
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTemplates();
  }, []);

  const fetchTemplates = async () => {
    try {
      const res = await axios.get(`${API_URL}/email-templates`);
      setTemplates(res.data);
    } catch (err) {
      toast.error('Error al cargar las plantillas');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Layout>
        <div className="flex items-center justify-center h-64">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#004E89]"></div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="space-y-6" data-testid="email-templates-page">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="font-manrope font-bold text-3xl text-slate-900 flex items-center gap-3">
              <Mail className="w-8 h-8 text-[#004E89]" />
              Plantillas de Email
            </h1>
            <p className="text-slate-500 mt-1">Personaliza el contenido y diseño de los emails que envía la plataforma</p>
          </div>
        </div>

        <div className="grid gap-3" data-testid="email-templates-list">
          {templates.map((template) => (
            <button
              key={template.type}
              onClick={() => navigate(`/email-templates/${template.type}`)}
              className="bg-white rounded-lg border border-slate-200 shadow-sm p-5 flex items-center gap-4 hover:border-[#004E89] hover:shadow-md transition-all text-left w-full group"
              data-testid={`template-item-${template.type}`}
            >
              <span className="text-2xl flex-shrink-0">{TYPE_ICONS[template.type] || '📧'}</span>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="font-semibold text-slate-900">{template.name}</h3>
                  {template.is_custom && (
                    <span className="px-2 py-0.5 bg-blue-100 text-blue-700 text-xs font-medium rounded-full flex items-center gap-1">
                      <Palette className="w-3 h-3" />
                      Personalizada
                    </span>
                  )}
                </div>
                <p className="text-sm text-slate-500 truncate">{template.description}</p>
              </div>
              <ChevronRight className="w-5 h-5 text-slate-400 group-hover:text-[#004E89] transition-colors flex-shrink-0" />
            </button>
          ))}
        </div>
      </div>
    </Layout>
  );
};

export default EmailTemplates;
